<template>
  <div class="auth-process-container">
    <div class="auth-process">
      <q-card bordered flat class="auth-process-card">
        <div class="auth-title" v-if="!demoMessage">Free Account Sign Up</div>
        <q-form @submit="onSubmit">
          <div class="row q-col-gutter-sm">
            <div class="col-lg-6 col-md-6 col-xs-12 col-sm-6" v-if="!demoMessage">
              <q-input
                ref="name"
                outlined
                label-color="grey-7"
                color="grey-7"
                lazy-rules
                label="First Name*"
                hide-bottom-space
                :rules="[val => (val !== null && val !== '') || 'Required Field.']"
                v-model="name"
              >
                <template #prepend>
                  <q-icon color="grey-7" size="14px" name="fas fa-user"></q-icon>
                </template>
              </q-input>
            </div>
            <div class="col-lg-6 col-md-6 col-xs-12 col-sm-6" v-if="!demoMessage">
              <q-input
                ref="surname"
                label-color="grey-7"
                color="grey-7"
                lazy-rules
                hide-bottom-space
                label="Last Name*"
                outlined
                v-model="surname"
                :rules="[val => (val !== null && val !== '') || 'Required Field.']"
              >
                <template #prepend>
                  <q-icon color="grey-7" size="14px" name="fas fa-user"></q-icon>
                </template>
              </q-input>
            </div>
            <div class="col-12" v-if="!demoMessage">
              <q-input
                ref="email"
                label-color="grey-7"
                color="grey-7"
                lazy-rules
                outlined
                v-model="email"
                hide-bottom-space
                label="Email*"
                :rules="[isValidEmail]"
              >
                <template v-slot:prepend>
                  <q-icon size="16px" color="grey-7" name="far fa-envelope" />
                </template>
              </q-input>
            </div>
            <div class="col-12" v-if="!demoMessage">
              <q-input
                ref="company"
                label-color="grey-7"
                color="grey-7"
                lazy-rules
                outlined
                v-model="companyName"
                hide-bottom-space
                label="Company Name*"
                :rules="[
                  val => (val !== null && val !== '') || '*Required Field.',
                  val => (val && val.length > 2) || 'Minimum 3 characters'
                ]"
              >
                <template v-slot:prepend>
                  <q-icon size="16px" color="grey-7" name="fas fa-briefcase" />
                </template>
              </q-input>
            </div>
            <div class="col-12" v-if="!demoMessage">
              <q-input
                ref="phone"
                :rules="[
                  val => (val !== null && val !== '') || '*Required Field.',
                  val => (val && val.length == 14) || 'Incorrect phone number.'
                ]"
                outlined
                color="grey-7"
                lazy-rules
                mask="(###)-###-####"
                label-color="grey-7"
                v-model="phone"
                label="Phone Number*"
              >
                <template v-slot:prepend>
                  <q-icon name="fas fa-phone" size="16px" color="grey-7"></q-icon>
                </template>
              </q-input>
            </div>
            <!-- <vue-recaptcha
              id="captcha"
              v-if="!demoMessage"
              class="captcha-wrapper"
              ref="recaptcha"
              @verify="onCaptchaVerified"
              @expired="onCaptchaExpired"
              sitekey="6Le7iLEeAAAAABWzgfr2Lf6lIZgruaviFWbikxbm"
            >
            </vue-recaptcha> -->

            <div id="thank-you-block" v-else class="text-black text-center">
              <img :src="require('../assets/brands/logo.png')" style="width:100%" />
              <div class="text-bold text-red" style="font-size:20px">
                THANK YOU
              </div>
              {{ demoMessage }}
              <div class="text-black text-center text-bold">
                For additional help or for any questions,please reach us at
                <a id="email-info-link" target="_blank" href="mailto:info@fcaus.org" class="text-primary text-normal"
                  >info@fcaus.org</a
                >
              </div>
            </div>
            <span class="text-caption">* Required Field</span>
            <div id="demo-redirect-btn" class="col-12 other-things redirect-btn">
              <span @click="$router.push({ name: 'login' })">Back to login.</span>
            </div>
            <div class="col-12" v-if="!demoMessage">
              <div class="auth-process-actions" style="margin-top: 3px">
                <q-btn
                  id="demo-submit-btn"
                  :loading="loading"
                  label="Start Free Account"
                  :disabled="loading"
                  type="submit"
                  color="positive"
                >
                  <template v-slot:loading>
                    <q-spinner-facebook />
                  </template>
                </q-btn>
              </div>
            </div>
          </div>
        </q-form>
      </q-card>
    </div>
  </div>
</template>

<script>
import axios from '../axios/index'
import VueRecaptcha from 'vue-recaptcha'
import isValidEmail from '../helper/emailValidation'
export default {
  components: { VueRecaptcha },
  name: 'login',
  data() {
    return {
      captchaToken: null,
      email: '',
      name: '',
      surname: '',
      loading: false,
      companyName: '',
      phone: '',
      demoMessage: null
    }
  },
  methods: {
    onCaptchaVerified(res) {
      this.captchaToken = res
    },
    onCaptchaExpired() {
      this.captchaToken = null
      this.$refs.recaptcha.reset()
    },
    isValidEmail,
    resetForm() {
      this.email = ''
      this.name = ''
      this.loading = false
      this.surname = ''
      this.companyName = ''
      this.phone = ''
      //  this.onCaptchaExpired();
      this.$refs.email.resetValidation()
      this.$refs.phone.resetValidation()
      this.$refs.surname.resetValidation()
      this.$refs.company.resetValidation()
      this.$refs.name.resetValidation()
    },
    errorHandler(message) {
      this.$q.notify({
        message,
        timeout: 2000,
        position: 'top-right',
        progress: true,
        type: 'negative'
      })
    },
    async onSubmit() {
      try {
        this.loading = true
        const body = {
          email: this.email.toLowerCase(),
          name: this.name,
          last_name: this.surname,
          company_name: this.companyName,
          phone: this.phone
            .split('(')
            .join('')
            .split(')')
            .join('')
            .split('-')
            .join('')
        }
        await axios.post('forms/demo-account-request', body)
        this.resetForm()
        this.demoMessage =
          'A link to demo site and your log-in information will be sent shortly to the email address you provided.'
        this.loading = false
        // this.onCaptchaExpired();
      } catch (error) {
        this.loading = false
        let message = ''
        if (error.response) {
          if (error.response.data.code == 422) {
            error.response.data.errors.forEach(error => {
              message += Object.values(error)[0] + '\n'
            })
          } else {
            message = error.response.data.message
          }
        } else {
          message = error.message
        }
        this.errorHandler(message)
        this.resetForm()
      }
    }
  },
  metaInfo() {
    return {
      title: 'Welcome to Fleet Management System | FMS',
      meta: [
        {
          name: 'description',
          // "FMS is about connecting in your field of interest. Our vision is to help people share their knowledge, work, projects, papers and ideas and build their network through what they do rather where they live, study or work.",
          content: ''
        },
        {
          property: 'og:title',
          content: 'Welcome to Fleet Management System | FMS'
        },
        { property: 'og:site_name', content: 'FMS' },
        { property: 'og:type', content: 'website' },
        { name: 'robots', content: 'index,follow' }
      ]
    }
  },
  mounted() {
    const nameRef = this.$refs.name
    const inputRef = nameRef.$refs.input
    inputRef.id = 'demo-input-name'

    const surnameRef = this.$refs.surname
    const inputPassRef = surnameRef.$refs.input
    inputPassRef.id = 'demo-input-surname'

    const emailRef = this.$refs.email
    const inputDemoRef = emailRef.$refs.input
    inputDemoRef.id = 'demo-input-email'

    const companyRef = this.$refs.company
    const inputComRef = companyRef.$refs.input
    inputComRef.id = 'demo-input-company'

    const phoneRef = this.$refs.phone
    const inputPhoneRef = phoneRef.$refs.input
    inputPhoneRef.id = 'demo-input-phone'
  }
}
</script>

<style scoped>
.redirect-btn {
  justify-content: center;
  align-items: center;
  display: flex;
}
</style>
